import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

function CookieConsent() {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    
    // Show consent banner if not accepted yet
    if (!cookieConsent) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowConsent(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowConsent(false);
  };

  if (!showConsent) {
    return null;
  }

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <h3>🍪 Cookie Policy</h3>
          <p>
            We use cookies to enhance your browsing experience, personalize content, analyze site traffic, 
            and provide social media features. By clicking "Accept," you consent to our use of cookies. 
            You can read our full{' '}
            <Link to="/cookie-policy" className="cookie-policy-link">
              Cookie Policy
            </Link>
            {' '}and{' '}
            <Link to="/privacy-policy" className="cookie-policy-link">
              Privacy Policy
            </Link>
            {' '}for more information.
          </p>
        </div>

        <div className="cookie-consent-buttons">
          <button 
            className="cookie-btn accept-btn" 
            onClick={handleAccept}
            aria-label="Accept cookies"
          >
            Accept All
          </button>
          <button 
            className="cookie-btn reject-btn" 
            onClick={handleReject}
            aria-label="Reject cookies"
          >
            Reject
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
